import { render, staticRenderFns } from "./newDrawer.vue?vue&type=template&id=67983c2c&scoped=true&"
import script from "./newDrawer.vue?vue&type=script&lang=js&"
export * from "./newDrawer.vue?vue&type=script&lang=js&"
import style0 from "./newDrawer.vue?vue&type=style&index=0&id=67983c2c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67983c2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67983c2c')) {
      api.createRecord('67983c2c', component.options)
    } else {
      api.reload('67983c2c', component.options)
    }
    module.hot.accept("./newDrawer.vue?vue&type=template&id=67983c2c&scoped=true&", function () {
      api.rerender('67983c2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/homeDrawer/drawer/newDrawer.vue"
export default component.exports